import React from 'react';
export default (function (_a) {
    var className = _a.className, ariaHidden = _a["aria-hidden"], color = _a.color;
    return (React.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round", className: className, "aria-hidden": ariaHidden, style: { fill: 'none' } },
        React.createElement("polygon", { points: "22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3" })));
});
